<template>
  <div id="productIntroduction" style="background-color: #F4F6F8;min-height: 905px">
    <div class="productBack">
      <div style="width: 1280px;text-align: left;display: inline-block">
        <div class="title">关于我们</div>
        <div class="subTitle">
          <div>
            北京构力科技有限公司
          </div>
          <div>
            CAE软件研发部
          </div>
        </div>
      </div>
    </div>
    <div class="main" style="background: white">
      <div class="content">
        <div style="width: 100%">
          <div class="title">发展历程</div>
          <div style="margin-top: 40px;margin-bottom: 48px">
            <img src="../../static/img/aboutUs/history.png" alt="" style="width: 1005px">
          </div>
        </div>

      </div>
      <div class="contactUs">
        <div class="content">
          <div class="title">联系我们</div>
          <div style="margin-top: 80px;display: flex;align-items: flex-start;justify-content: space-around">
            <div style="display: inline-block;margin-top: 15px">
              <div style="text-align: left">
                <div>
                  <img src="../../static/img/aboutUs/address.png" alt="" style="display: inline-block">
                  <div style="display: inline-block;text-align: left;vertical-align: bottom;margin-left: 13px">
                    <div style="font-size: 16px;color: #999999;">地址</div>
                    <div style="font-size: 16px;color: #333333;">北京市朝阳区和平街街道北三环东路30号</div>
                  </div>
                </div>
                <div style="width: 450px;height: 1px;background: #E6E5E5;margin-top: 32px"></div>
                <div>
                  <img src="../../static/img/aboutUs/phone.png" alt="" style="display: inline-block">
                  <div
                    style="display: inline-block;text-align: left;vertical-align: bottom;margin-left: 13px;margin-top: 32px">
                    <div style="font-size: 16px;color: #999999;">联系电话</div>
                    <div style="font-size: 16px;color: #333333;">400-8000-900</div>
                  </div>
                </div>
                <div style="width: 450px;height: 1px;background: #E6E5E5;margin-top: 32px"></div>
                <div>
                  <img src="../../static/img/aboutUs/email.png" alt="" style="display: inline-block">
                  <div
                    style="display: inline-block;text-align: left;vertical-align: bottom;margin-left: 13px;margin-top: 32px">
                    <div style="font-size: 16px;color: #999999;">电子邮箱</div>
                    <div style="font-size: 16px;color: #333333;">cae@cabrtech.com</div>
                  </div>
                </div>
                <div style="width: 450px;height: 1px;background: #E6E5E5;margin-top: 32px"></div>
                <div>
                  <img src="../../static/img/aboutUs/tecCon.png" alt="" style="display: inline-block">
                  <div
                    style="display: inline-block;text-align: left;vertical-align: bottom;margin-left: 13px;margin-top: 32px">
                    <div style="font-size: 16px;color: #999999;">技术交流</div>
                    <div style="font-size: 16px;color: #333333;">PKPMCAE技术交流群</div>
                  </div>
                  <div style="position: relative;top: -70px;left: 400px">
                    <img src="../../static/img/aboutUs/QRcode.png" alt="">
                  </div>
                </div>

              </div>
            </div>
            <div style="text-align: right;display: inline-block">
              <img src="../../static/img/aboutUs/local.png" alt="" style="width: 640px;">
            </div>
          </div>
        </div>
      </div>
      <div class="partner">
        <div class="title">
          生态伙伴
        </div>
        <div class="partners">
          <div style="display: flex;justify-content: space-between">
            <img src="../../static/img/aboutUs/companys/1.png" alt="">
            <img src="../../static/img/aboutUs/companys/2.png" alt="">
            <img src="../../static/img/aboutUs/companys/3.png" alt="">
            <img src="../../static/img/aboutUs/companys/4.png" alt="">
            <img src="../../static/img/aboutUs/companys/5.png" alt="">
            <img src="../../static/img/aboutUs/companys/6.png" alt="">
          </div>
          <div style="display: flex;justify-content: space-between;margin-top: 20px">
            <img src="../../static/img/aboutUs/companys/7.png" alt="">
            <img src="../../static/img/aboutUs/companys/8.png" alt="">
            <img src="../../static/img/aboutUs/companys/9.png" alt="">
            <img src="../../static/img/aboutUs/companys/10.png" alt="">
            <img src="../../static/img/aboutUs/companys/11.png" alt="">
            <img src="../../static/img/aboutUs/companys/12.png" alt="">
          </div>
          <div style="display: flex;justify-content: space-between;margin-top: 20px">
            <img src="../../static/img/aboutUs/companys/13.png" alt="">
            <img src="../../static/img/aboutUs/companys/14.png" alt="">
            <img src="../../static/img/aboutUs/companys/15.png" alt="">
            <img src="../../static/img/aboutUs/companys/16.png" alt="">
            <img src="../../static/img/aboutUs/companys/17.png" alt="">
            <img src="../../static/img/aboutUs/companys/18.png" alt="">
          </div>
          <div style="display: flex;margin-top: 20px">
            <img src="../../static/img/aboutUs/companys/19.png" alt="">
            <img src="../../static/img/aboutUs/companys/20.png" alt="" style="margin-left: 20px">


          </div>
        </div>
      </div>
    </div>


  </div>


</template>

<script>
import axios from 'axios'
import {getCmsList, listCategory, searchFiles, listRelationFiles} from '../api/index'
import utils from '../lib/utils'

export default {
  name: "aboutUs",
  data() {
    return {}
  },

  methods: {},
  mounted() {
    window.scrollTo(0, 0)
  }
}
</script>

<style scoped lang="scss">
.productBack {
  width: 100%;
  height: 280px;
  background: url("../../static/img/aboutUs/aboutUsBack.png");
  text-align: center;

  .title {
    font-weight: 600;
    font-size: 32px;
    color: #FFFFFF;
    margin-top: 118px;
  }

  .subTitle {
    width: 60%;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    margin-top: 8px;
  }
}

.main {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .title {
    margin-top: 80px;
    font-weight: 600;
    font-size: 24px;
    color: #333333;
  }


  .content {
    width: 1280px;
  }

  .contactUs {
    display: flex;
    width: 100%;
    height: 716px;
    background: url("../../static/img/aboutUs/contactUsBack.png") no-repeat;
    background-size: cover;
    justify-content: center;
  }

  .partner {
    width: 1280px;

    .partners {
      margin-top: 60px;
      margin-bottom: 100px;
    }
  }

}


</style>



// WEBPACK FOOTER //
// src/components/aboutUs.vue